export default "__VITE_ASSET__7216085a__"